import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import OtherService from '../services/Other'
import Loader from '../component/Loader'
import PrimaryGradientButton from '../component/PrimaryGradientButton'

const DocumentSingle = () => {
    const { contentId } = useParams()
  //All States
  const [isDocList, setIsDocList] = useState([])
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  //All useEffect//
  useEffect(() => {
    const galleryDocData = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const galleryDocResponse = await OtherService.gallery(token,contentId);
        if (galleryDocResponse.error == false) {
          if (galleryDocResponse.data.docDetails.length > 0) {
            // The API always returns every document in the gallery
            // spot, so pick the one matching the current contentId
            // instead of always taking the first one.
            const matchedDoc =
              galleryDocResponse.data.docDetails.find(
                (doc) =>
                  String(doc.contentDetails?.id) ===
                  String(contentId)
              ) || galleryDocResponse.data.docDetails[0]

            setIsDocList(matchedDoc.files);
            setLoading(false)
            setNoData(false)
          }
          else {
            setLoading(false)
            setNoData(true)
          }

        }
        else {
          setLoading(false)
          setNoData(true)
        }
      }
      catch (error) {
        console.error('Error:');
      }
    }
    galleryDocData()
  }, [])

  const handleDownload = (filePath) => {
    window.open(filePath, '_blank');
  };
  const navigate = useNavigate()
  const handleBack = () =>{
    navigate(`/document-gallery`);
  }
  return (
    <>
    {loading && <Loader />}
   
    <BreadCrumbSecttion
      pageTitle="Document"
      currentPageName="Document" />
        <section className='padTop50'>
        <Container>
          <Row>
            <Col xs={12}>
              <div className='buttonWrap my-4'>
                <PrimaryGradientButton buttonText="Back" onClick={handleBack} />
                
              </div>
            </Col>
          </Row>
        </Container>
            <Container>
                <div className='userInfoBox'>
                {noData && 
                    <Row>
                      <Col><div className="noDataMsg">No data found!</div></Col>
                    </Row>
                     }
                <Row>
                    {isDocList?.map((item) => {
                    const { id, title, thumbnail_image,file_path} = item
                    return (
                        <Col xs={12} lg={3} key={id} className='galleryImgBox'>
                        <div className='itemWrap'>
                            <div className='itemWrapImage'>
                            <img src={thumbnail_image} className='img-fluid' alt='imageName' />
                            </div>
                            <div className="itemWrapImageTxtDoc"><p>{title}</p></div>
                            <PrimaryGradientButton buttonText="Download" onClick={() => handleDownload(file_path)}/>
                        </div>

                        </Col>
                    )
                    })}

                </Row>
                </div>

            </Container>
        </section>
  </>
  )
}

export default DocumentSingle